/**
 * 게스트 등록 SMS 플레이스홀더 정의
 * @description 미등록 화주의 주문 등록 완료 시 발송되는 SMS 템플릿에서 사용 가능한 변수.
 *   ULA 앱 smsPlaceholders.ts의 정의와 색상 체계를 공유한다.
 */

import type { PlaceholderConfig } from "../types/sms.types";

/**
 * 플레이스홀더 카테고리별 색상
 */
export const PLACEHOLDER_COLORS = {
  배차업체: "#0EA5E9", // Sky
  주문: "#6366F1", // Indigo
  상차지: "#10B981", // Emerald
  하차지: "#F59E0B", // Amber
  화물: "#8B5CF6", // Violet
  시스템: "#64748B", // Slate (백엔드 치환 placeholder)
} as const;

/**
 * 게스트 등록 SMS 플레이스홀더 목록
 * @description 태그 에디터의 팔레트/슬래시 메뉴에서 사용
 */
export const GUEST_SMS_PLACEHOLDERS: PlaceholderConfig[] = [
  {
    placeholder: "#{DispatchCorpSmsBrand}",
    label: "배차업체 SMS 브랜드명",
    color: PLACEHOLDER_COLORS.배차업체,
    category: "배차업체",
    description: "SMS 발신 브랜드명([나래화물]). 미설정 시 배차업체명으로 대체",
  },
  {
    placeholder: "#{OrderNum}",
    label: "주문번호",
    color: PLACEHOLDER_COLORS.주문,
    category: "주문",
    description: "화물 주문번호",
  },
  {
    placeholder: "#{LoadAddr}",
    label: "상차지 기본주소",
    color: PLACEHOLDER_COLORS.상차지,
    category: "상차지",
    description: "상차지 주소 (시/도, 시/군/구, 읍/면/동)",
  },
  {
    placeholder: "#{LoadAddrDetail}",
    label: "상차지 상세주소",
    color: PLACEHOLDER_COLORS.상차지,
    category: "상차지",
    description: "상차지 상세 주소",
  },
  {
    placeholder: "#{DropAddr}",
    label: "하차지 기본주소",
    color: PLACEHOLDER_COLORS.하차지,
    category: "하차지",
    description: "하차지 주소 (시/도, 시/군/구, 읍/면/동)",
  },
  {
    placeholder: "#{DropAddrDetail}",
    label: "하차지 상세주소",
    color: PLACEHOLDER_COLORS.하차지,
    category: "하차지",
    description: "하차지 상세 주소",
  },
  {
    placeholder: "#{Items}",
    label: "품목",
    color: PLACEHOLDER_COLORS.화물,
    category: "화물",
    description: "화물 품목",
  },
  {
    placeholder: "#{GuestOrderShortLinkUrl}",
    label: "게스트 숏링크",
    color: PLACEHOLDER_COLORS.시스템,
    category: "시스템",
    description: "백엔드에서 발행되는 게스트 주문 단축 URL",
  },
];
